<template>
  <v-tooltip location="top">
    <template #activator="{ props }">
      <div v-bind="props" ref="qrRef">
        <span v-if="qrError" class="text-error">QR code failed to render</span>
      </div>
    </template>
    <span>Scan this QR code to access your aquarium details on the go. Print it out and stick it on your aquarium!</span>
  </v-tooltip>
</template>

<script setup>
import { onMounted, onBeforeUnmount, watch, ref, computed } from 'vue'
import QRCodeStyling from 'qr-code-styling'

const props = defineProps({
  id: {
    type: Number,
    required: true
  }
})

const qrRef = ref(null)
let qrCode = null
const qrError = ref(false)

const url = computed(() => `https://reeflendar.com/aquarium/${props.id}`)

const generateQrCode = () => {
  qrError.value = false
  if (qrRef.value) {
    qrRef.value.innerHTML = ''
  }
  try {
    if (qrCode) {
      qrCode.update({ data: url.value, image: '/logo.png' })
      qrCode.append(qrRef.value)
      return
    }
    qrCode = new QRCodeStyling({
      width: 150,
      height: 150,
      data: url.value,
      image: '/logo.png', // Make sure logo.png is in /public
      dotsOptions: {
        color: "#000",
        type: "square"
      },
      backgroundOptions: {
        color: "#ffffff"
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 1.0,
        //crossOrigin: "anonymous",
        margin: 0.5
      }
    })
    if (qrRef.value) {
      qrCode.append(qrRef.value)
    }
  } catch (e) {
    qrError.value = true
  }
}

onMounted(() => {
  generateQrCode()
})

watch(() => props.id, () => {
  generateQrCode()
})

onBeforeUnmount(() => {
  if (qrRef.value) {
    qrRef.value.innerHTML = ''
  }
})
</script>
